import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../../shared/services/payment.service';

@Component({
  selector: 'pa-threed',
  templateUrl: './threed.component.html',
  styleUrls: ['./threed.component.scss']
})
export class ThreedComponent implements OnInit {
  trackingId: string;

  constructor(private route: ActivatedRoute, private router: Router, private paymentService: PaymentService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
    this.route.queryParams.subscribe(params => {
      let sessionId: string = params.sessionId;
      if (!sessionId) {
        this.router.navigate(['/result/error', this.trackingId]);
        return;
      }

      this.paymentService.getThreeDContent(sessionId, this.trackingId).subscribe(
        response => {
          let threeDScreen;
          threeDScreen = window;
          threeDScreen.document.open();
          threeDScreen.document.write(response?.content);
          threeDScreen.document.close();
        },
        error => {
          this.router.navigate(['/result/error', this.trackingId]);
        }
      )
    });
  }

}
